(function () {
  const containers = document.querySelectorAll('.scroll-container');
  if (!containers.length) return;

  containers.forEach((container) => {
    const track = container.querySelector('.carousel-track') as HTMLElement;
    const prev = container.querySelector(
      '.carousel-prev'
    ) as HTMLElement | null;
    const next = container.querySelector(
      '.carousel-next'
    ) as HTMLElement | null;

    if (!track) return;

    const scrollAmount = () => {
      const item = track.querySelector('div');
      return item ? item.offsetWidth : 0;
    };

    const setButtonEnabled = (button: HTMLElement | null, enabled: boolean) => {
      if (!button) return;
      button.classList.toggle('opacity-40', !enabled);
      button.classList.toggle('pointer-events-none', !enabled);
    };

    const hideButtons = () => {
      prev?.classList.add('hidden');
      next?.classList.add('hidden');
    };

    const updateButtonStates = () => {
      const scrollTolerance = 2;
      const maxScrollLeft =
        track.scrollWidth - track.clientWidth - scrollTolerance;
      setButtonEnabled(prev, track.scrollLeft > 0);
      setButtonEnabled(next, track.scrollLeft < maxScrollLeft);
      if (maxScrollLeft <= 0) {
        hideButtons();
      }
    };

    const scrollByAmount = (direction: number) => {
      track.scrollBy({
        left: direction * scrollAmount(),
        behavior: 'smooth',
      });
    };

    track.addEventListener('scroll', updateButtonStates);
    updateButtonStates();

    prev?.addEventListener('click', () => scrollByAmount(-1));
    next?.addEventListener('click', () => scrollByAmount(1));
  });
})();
